exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "profile-selection .relative-pos{position:relative}profile-selection .invitations-row{position:absolute;top:5px;right:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/profile-selection/profile-selection.scss
// module id = 1289
// module chunks = 0